import 'script-loader!node_modules/slick-carousel/slick/slick.js';
require('script-loader!.tmp/js/templates/location/modules/Reviews.js');

export class Reviews {
  constructor() {
    updateReviewsSection();
  }
}

async function getReviewsProps() {
  const entityID = window.Yext.LocationId
  const urlParams = {
    'entity.id': entityID,
    api_key: 'cfbe3fb770248dab601f0db9db679b16', // eslint-disable-line
    v: '20221227',
    limit: 25,
  };
  const [reviewsAgg, reviews] = await Promise.all([
    getReviewsAgg(urlParams),
    getReviews(urlParams),
  ]);

  return {
    reviews,
    reviewsCount: reviewsAgg.reviewCount,
    reviewsAverage: Math.round(reviewsAgg.averageRating * 10) / 10,
  };
}

function buildURL(url, params) {
  let paramString = Object.entries(params).map(([key, val]) => `${key}=${val}`).join('&');
  if (paramString) { paramString = `?${paramString}`; }
  return `${url}${paramString}`;
}

async function doFetch(url) {
  try {
    const resp = await fetch(url, { method: 'GET', headers: { Accept: 'application/json' } });
    return resp.json();
  } catch (err) {
    return Promise.reject(err);
  }
}

async function getReviews(params) {
  const reviewsEndpoint = 'https://streams.yext.com/v2/accounts/me/api/streams-api-reviews';
  params.$sortBy__desc = 'reviewDate'
  const url = buildURL(reviewsEndpoint, params);
  const { response } = await doFetch(url);
  if (response && response.docs) {
    return response.docs;
  }
  return [];
}

async function getReviewsAgg(params) {
  const reviewsAggEndpoint = 'https://streams.yext.com/v2/accounts/me/api/streams-api-reviewsagg';
  const url = buildURL(reviewsAggEndpoint, params);
  const { response } = await doFetch(url);
  if (response && response.docs && response.docs.length > 0) {
    return response.docs[0];
  }
  return [];
}

async function updateReviewsSection() {
  const reviewsEl = document.querySelector('.js-reviews');
  const reviewsContentEl = document.querySelector('.js-reviews-soy2js-content');
  const locationInfoReviewEl = document.querySelector('.js-reviews-locationinfo-soy2js-content');
  if (reviewsEl && reviewsContentEl && locationInfoReviewEl) {
    const reviewsProps = await getReviewsProps();

    // Format the timestamps here because soy2js ltimestampf doesn't exist
    reviewsProps.reviews.forEach((review) => {
      const d = new Date(review.reviewDate);
      review.formattedDate = d.toLocaleDateString(window.Yext.Locale.replace(/_.*/, '')); // eslint-disable-line
      if (review.comments) {
        review.comments.forEach((comment) => {
          const d = new Date(comment.commentDate);
          comment.formattedDate = d.toLocaleDateString(window.Yext.Locale.replace(/_.*/, '')); // eslint-disable-line
        });
      }
    });

    // No reviews -> remove the section
    if (!reviewsProps.reviews || reviewsProps.reviewsAverage < 4.0) {
      reviewsEl.remove();
      locationInfoReviewEl.remove();
      return;
    }

    reviewsContentEl.innerHTML = location.modules.Reviews_soy2js_content(reviewsProps);
    locationInfoReviewEl.innerHTML = location.modules.Reviews_locationinfo_soy2js_content(reviewsProps);

    let index = 0;
    const maxReviewsPerPage = 3;
    updatePagination(index, maxReviewsPerPage);

    const prevButton = document.querySelector('.Reviews-prevButton');
    if (prevButton) {
      prevButton.addEventListener('click', (() => {
        if (index > 0) {
          index -= 1;
        }
        updatePagination(index, maxReviewsPerPage);
      }))
    }
    const nextButton = document.querySelector('.Reviews-nextButton');
    if (nextButton) {
      nextButton.addEventListener('click', (() => {
        const reviews = document.querySelectorAll('.Reviews-listItem');
        if (index < Math.floor((reviews.length - 1) / maxReviewsPerPage)) {
          index += 1;
        }
        updatePagination(index, maxReviewsPerPage);
      }))
    }

    const paginationButtons = [
      '.Reviews-paginationButton1',
      '.Reviews-paginationButton2',
      '.Reviews-paginationButton3',
      '.Reviews-paginationButton4',
      '.Reviews-paginationButton5',
    ];
    for (let i = 0; i < paginationButtons.length; i++) {
      const button = document.querySelector(paginationButtons[i]);
      if (button) {
        button.addEventListener('click', (() => {
          index = i;
          updatePagination(index, maxReviewsPerPage);
        }))
      }
    }
  }
}

function updatePagination(index, maxReviewsPerPage) {
  const reviews = document.querySelectorAll('.Reviews-listItem');
  for (let i = 0; i < reviews.length; i++) {
    if (i >= index * maxReviewsPerPage && i < (index + 1) * maxReviewsPerPage) {
      reviews[i].classList.remove('is-hidden');
    } else {
      reviews[i].classList.add('is-hidden');
    }
  }

  const paginationButtons = [
    '.Reviews-paginationButton1',
    '.Reviews-paginationButton2',
    '.Reviews-paginationButton3',
    '.Reviews-paginationButton4',
    '.Reviews-paginationButton5',
  ];
  for (let i = 0; i < paginationButtons.length; i++) {
    const button = document.querySelector(paginationButtons[i]);
    if (i == index) {
      button.classList.add('Reviews-currentPagination');
    } else {
      button.classList.remove('Reviews-currentPagination');
    }
  }
}
